<template>
  <section>
    <div class="flex-1 w100">
      <div class="flex">
        <tabs :data="productTabs" v-model="currentTab"></tabs>
      </div>
    </div>

    <div v-if="currentTab === 'callback'" class="flex column">
      <div class="box w100">
        <div class="box-title">
          <h3>CallBack V1 - Único Tracker</h3>
        </div>
        <div class="box-content">
          <p>
            Integre a Único Tracker com outros sistemas usando nossas callbacks.
          </p>
          <p class="margin-top-s">
            Para ler a documentação acesse:
            <a href="https://dev.unicotracker.com.br/callback" target="_blank"
              >https://dev.unicotracker.com.br/callback</a
            >
          </p>
          <p class="margin-top-s">
            <b>Atenção:</b> O Acesso as CALL BACKS é liberado apenas para
            assinantes de planos pagos.
          </p>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="showModalCreateOrUpdate = true">
                Criar nova Call Back
              </div>
            </div>
          </div>

          <div class="list-webhooks flex w100 margin-top-l">
            <ul class="w100">
              <li v-for="(w, index) in webhooks" :key="index">
                <div class="flex w100">
                  <div class="flex-2">
                    <div class="name">{{ w.name }}</div>
                    <div class="url margin-top-s">{{ w.url }}</div>
                  </div>
                  <div class="flex-1">
                    <div class="flex end actions">
                      <div class="button primary" @click="openModalEdit(index)">EDITAR</div>
                      <div class="button secondary" @click="openModalDelete(index)">EXCLUIR</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="currentTab === 'log'" class="box">
      <div class="box-title">
          <p>Contém os últimos 50 registros de disparo do webhook</p>
        </div>
      <div class="box-content">
        <div class="list-webhooks flex w100 margin-top-l">
          <ul class="w100">
              <li v-for="(l, index) in logs" :key="index">
                <div class="flex w100 middle">
                  <div class="flex-2">
                    <div class="name">{{ l.url }}</div>
                    <div class="margin-top-s">{{ l.created_at | date }}</div>
                  </div>
                  <div class="flex-1 flex end">
                    <div class="end">
                      <div>Status: <b>{{ l.status }}</b></div>
                    </div>
                  </div>
                </div>
              </li>
          </ul>
        </div>
        <div v-if="loaderLogs">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <modal
        title="Criar nova CallBack"
        :show="showModalCreateOrUpdate"
        @close="closeModalEdit()"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Nome</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newWebhook.name"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>Url:</label>
                <input
                  class="input"
                  id="url"
                  type="text"
                  v-model="newWebhook.url"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>Tipo:</label>
                <select class="input" v-model="newWebhook.type">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listTypeWebhook" :key="index" :value="f.value" :selected="f.value === newWebhook.type">
                    {{ f.label }}
                  </option>
                </select>
              </div>

            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="saveNewWehhook()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModal"
      description="Você tem certeza que deseja remover o webhook?"
      @cancel="closeModalDelete()"
      @accept="removeWebhookToList()"
    ></modal-confirm>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";
import Modal from "@/components/modal/Modal";

import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";

import {
  getLogs
} from "@/services/webhooklog"

import ModalConfirm from "@/components/modal/ModalConfirm";

const emptyWebhook = {
    name: '',
    url: '',
    type: '',
}

export default {
  name: "open-webhook",
  components: {
    ModalConfirm,
    Tabs,
    Modal,
  },
  data() {
    return {
      showModalCreateOrUpdate: false,
      showModal: false,
      currentTab: "callback",
      removeWebhookIndex: null,
      listTypeWebhook: [ 
        {
          value: 'NEW-SALE', label:"Nova Venda"
        }
        
      ],
      productTabs: [
        {
          name: "callback",
          title: "CallBack",
        },
        //{
        //  name: "log",
        //  title: "Logs",
        //},
      ],
      newWebhook: Object.assign({}, emptyWebhook),
      webhooks: [],
      logs: [],
      loaderLogs: false,
      page: 1,
      offset: 50,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
    this.getLogs()
  },
  methods: {
    openModalEdit(index) {
      this.newWebhook = this.webhooks[index]
      this.newWebhook.id = index
      this.showModalCreateOrUpdate = true
    },
    closeModalEdit() {
      this.newWebhook = Object.assign({}, emptyWebhook)
      this.showModalCreateOrUpdate = false
    },
    openModalDelete(index) {
      this.showModal = true
      this.removeWebhookIndex = index
    },
    closeModalDelete() {
      this.showModal = false
      this.removeWebhookIndex = null
    },
    removeWebhookToList() {
      this.webhooks = this.webhooks.splice(this.removeWebhookIndex, 1)
      this.showModal = false
      this.updateWebhook()
    },
    saveNewWehhook() {
      if (!this.newWebhook.name || !this.newWebhook.url || !this.newWebhook.type) {
        this.$toast.error({
          title:'Erro',
          message:'Você precisa preencher todos os dados'
        })
        return
      }
      
      // is new webhook to create
      if (this.newWebhook.id === undefined) {
        this.webhooks.push(this.newWebhook)
      }

      this.showModalCreateOrUpdate = false
      this.newWebhook = Object.assign({}, emptyWebhook)
      this.updateWebhook()
    },
    updateWebhook() {
      let params = {
        openwebhook: {
          webhooks: this.webhooks
        },
      };
      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Call Back Criado com sucesso",
          });

          this.showModal = false;

          this.getIntegrations();
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar criar",
          });
        });
    },
    getLogs() {
      this.loaderLogs = true
      
      let params = {
        page: this.page,
        offset: this.offset
      }
      getLogs(params)
        .then((result) => {
          this.logs = result.logs
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loaderLogs = false
        })
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.webhooks = result.openwebhook.webhooks;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.input.readonly {
  background: #f5f4f4 !important;
}
.list-webhooks {
  ul {
    list-style-type: none;
    li {
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--border);
    }
  }
  .name {
    font-weight: 800;
  }
  .actions {
    .button {
      margin-left: 8px;
    }
  }
}
</style>
